import React from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Sidebar = ({ 
  sections, 
  activeSection, 
  onSectionChange, 
  isMobileMenuOpen, 
  onCloseMobileMenu,
  formData
}) => {
  const getCompletionStatus = () => {
    // Debug: Log data to understand the structure
    console.log('Team data for completion check:', formData.teamMembers);
    console.log('Metrics data for completion check:', formData.metrics);
    
    const status = {
      'company-info': Boolean(
        formData.name &&
        formData.tagline &&
        formData.logo &&
        formData.website &&
        formData.founded &&
        formData.location &&
        formData.stage
      ),
      'metrics': Boolean(
        formData.metrics && 
        formData.metrics.stage && 
        (() => {
          // Check if at least 2 metrics are filled for the selected stage
          const stageMetrics = {
            'idea': ['marketSize', 'problemValidation', 'solutionFit'],
            'pre-seed': ['mvpUsers', 'userRetention', 'feedback', 'partnerships'],
            'seed': ['monthlyUsers', 'monthlyRevenue', 'growthRate', 'customerAcquisition'],
            'series-a': ['annualRevenue', 'customerCount', 'netRetention', 'burnRate', 'runway'],
            'series-b': ['arr', 'enterpriseCustomers', 'international', 'teamSize', 'marketShare'],
            'custom': ['custom1', 'custom2', 'custom3', 'custom4']
          };
          
          const currentStageMetrics = stageMetrics[formData.metrics.stage] || [];
          const filledMetrics = currentStageMetrics.filter(metric => 
            formData.metrics[metric] && formData.metrics[metric].trim() !== ''
          );
          
          // Require at least 2 metrics to be filled
          return filledMetrics.length >= 2;
        })()
      ),
      'team': Boolean(
        formData.teamMembers.length > 0 &&
        formData.teamMembers.some(member => 
          (member.firstName && member.lastName) || member.name
        ) &&
        formData.teamMembers.some(member => member.role)
      ),
      'pitch-deck': Boolean(formData.pitchDeck.uploaded),
      'financials': Boolean(
        formData.financials.year1 &&
        formData.financials.year2 &&
        formData.financials.year3 &&
        formData.financials.year4 &&
        formData.financials.year5
      ),
      'due-diligence': Boolean(
        formData.documents && 
        formData.documents.filter(d => d.required && d.uploaded).length >= 3
      ),
      'product-demo': Boolean(
        formData.productDemo && (
          formData.productDemo.videoUrl ||
          formData.productDemo.demoLink ||
          formData.productDemo.features?.length > 0
        )
      )
    };

    console.log('Completion status results:', status);
    return status;
  };

  const completionStatus = getCompletionStatus();

  return (
    <div className={`fixed lg:static inset-y-0 left-0 w-80 bg-white rounded-2xl shadow-lg p-6 h-fit z-20 transform transition-transform duration-300 ease-in-out lg:transform-none ${
      isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
    }`}>
      <div className="flex justify-between items-center mb-6">
        <Link to="/" className="flex items-center space-x-2 group">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-400 to-purple-400 rounded-lg flex items-center justify-center">
            <span className="text-sm font-bold text-white">DL</span>
          </div>
          <span className="text-xl font-light tracking-wider text-gray-800 group-hover:text-blue-500 transition-colors">DeckLink<span className="text-blue-400">.co</span></span>
        </Link>
        <button
          onClick={onCloseMobileMenu}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>
      </div>
      <nav className="space-y-2">
        {sections.map((section) => {
          const IconComponent = section.icon;
          return (
            <button
              key={section.id}
              onClick={() => {
                onSectionChange(section.id);
                onCloseMobileMenu();
              }}
              className={`w-full flex items-center gap-3 p-3 rounded-xl text-left transition-all ${
                activeSection === section.id
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <IconComponent className="w-5 h-5" />
              {section.title}
            </button>
          );
        })}
      </nav>

      {/* Progress Overview */}
      <div className="mt-8 p-4 bg-blue-50 rounded-xl">
        <h3 className="font-bold text-gray-800 mb-3">Completion Status</h3>
        <div className="space-y-2 text-sm">
          {sections.map((section) => (
            <div key={section.id} className="flex justify-between">
              <span>{section.title}</span>
              <span className={
                completionStatus[section.id]
                  ? "text-green-600"
                  : section.id === 'due-diligence'
                    ? "text-yellow-600"
                    : "text-red-600"
              }>
                {completionStatus[section.id]
                  ? "✓"
                  : section.id === 'due-diligence'
                    ? "!"
                    : "✗"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 